import { useRouter } from '@boss/hooks';

import { mapNextToContentfulLocaleMarket } from '../../utils/localeMapper';

/**
 * Returns a localized country name based on the provided language and countryCode
 * E.g: language: "fr" and countryCode "BE" results in Belgique
 */
const getLocalizedCountryName = (language: string, countryCode: string) => {
  try {
    // Validate language code
    if (!language || !Intl.DisplayNames.supportedLocalesOf(language).length) {
      return countryCode;
    }
    return (
      new Intl.DisplayNames([language], {
        type: 'region',
      }).of(countryCode) || countryCode
    );
  } catch (error) {
    console.warn(`Failed to get localized country name for ${countryCode} in ${language}:`, error);
    return countryCode;
  }
};

/**
 * useCountry hook which exports generic country information
 */
export const useCountry = () => {
  const { locale } = useRouter();

  const _locale = mapNextToContentfulLocaleMarket(locale);

  const [language, countryCode] = _locale.split('-');

  const countryName = getLocalizedCountryName(language, countryCode);

  return { countryCode, countryName, getLocalizedCountryName };
};
